import { useEffect, useRef } from "react";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App/model/app.store";
import { isSeaSavedShipmentModel } from "entities/SeaSavedCard";
import { isSeaSearchShipmentModel } from "entities/SeaSearchCard";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";

import { getInitialSearchQPM } from "../ParamsManager";

type UseSeaUrlQueryHandlerProps = {
  openedCard: ShipmentModel | null;
};

export const useSeaUrlQueryHandler = ({ openedCard }: UseSeaUrlQueryHandlerProps) => {
  const dispatch = useAppDispatch();
  const openedCardQPM = useRef(getInitialSearchQPM()).current;
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  const { isCurrentViewOpenedCard } = usePanelViews();

  useEffect(() => {
    if (!isCurrentViewOpenedCard) return;
    if (requestedFromUrl || !openedCard?.reference) return;

    openedCardQPM.set("number", openedCard.reference);

    if (isSeaSearchShipmentModel(openedCard) || isSeaSavedShipmentModel(openedCard)) {
      if (openedCard?.referenceType) {
        openedCardQPM.set("type", openedCard.referenceType);
      }
    }

    if (isSeaSavedShipmentModel(openedCard)) {
      const sealine = openedCard?.carrierScac;
      if (sealine) {
        openedCardQPM.set("sealine", sealine);
      }
    }
    if (isSeaSearchShipmentModel(openedCard)) {
      const sealine = openedCard?.getCarrierScac();
      if (sealine) {
        openedCardQPM.set("sealine", sealine);
      }
    }

    openedCardQPM.update();
  }, [openedCard?.rawData]);

  useEffect(
    () => () => {
      openedCardQPM.clear();
      openedCardQPM.update();
      dispatch(appStore.actions.setRequestedFromUrl(false));
    },
    []
  );
};
